import { render, staticRenderFns } from "./GradeManagmentDashboard.vue?vue&type=template&id=1214fd92&scoped=true"
import script from "./GradeManagmentDashboard.vue?vue&type=script&lang=js"
export * from "./GradeManagmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./GradeManagmentDashboard.vue?vue&type=style&index=0&id=1214fd92&prod&scoped=true&lang=css"
import style1 from "./GradeManagmentDashboard.vue?vue&type=style&index=1&id=1214fd92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214fd92",
  null
  
)

export default component.exports